import type {IABTestConfiguration} from "@pg-mono/ab-testing";

import {OngoingABTests} from "./ongoing_ab_tests_enum";

export const OPEN_PRICES_AB_TEST_ID = "PPLLkz697ghj77zzlz67";

const OPEN_PRICES_CONTROL_VARIANT = "control" as const;
export const OPEN_PRICES_VARIANT = "open-prices" as const;

export const openPricesAbTests: IABTestConfiguration = {
    id: OPEN_PRICES_AB_TEST_ID,
    name: OngoingABTests.OPEN_PRICES,
    expires: new Date(2026, 11, 31),
    path: [],
    variants: [OPEN_PRICES_CONTROL_VARIANT, OPEN_PRICES_VARIANT],
    variantConfig: {
        [OPEN_PRICES_CONTROL_VARIANT]: 0.9,
        [OPEN_PRICES_VARIANT]: 0.1
    },
    withSSR: true,
    matchOnAllPaths: true
};
import type {IABTestConfiguration} from "@pg-mono/ab-testing";

import {OngoingABTests} from "./ongoing_ab_tests_enum";

export const OPEN_PRICES_AB_TEST_ID = "PPLLkz697ghj77zzlz67";

const OPEN_PRICES_CONTROL_VARIANT = "control" as const;
export const OPEN_PRICES_VARIANT = "open-prices" as const;

export const openPricesAbTests: IABTestConfiguration = {
    id: OPEN_PRICES_AB_TEST_ID,
    name: OngoingABTests.OPEN_PRICES,
    expires: new Date(2026, 11, 31),
    path: [],
    variants: [OPEN_PRICES_CONTROL_VARIANT, OPEN_PRICES_VARIANT],
    variantConfig: {
        [OPEN_PRICES_CONTROL_VARIANT]: 0.9,
        [OPEN_PRICES_VARIANT]: 0.1
    },
    withSSR: true,
    matchOnAllPaths: true
};
